import {
  } from "./action";
  
  const initialState = {
    processing: false,
    error: false
  };
  
  export default function(state: any = initialState, action: Function) {
    switch (action.type) {
      
      default:
        return {
          ...state
        };
    }
  }